import { artworksService } from '../services';

export const searchArtworks = async (query) => {
  try {
    const { data, error } = await artworksService.searchArtworks(query);
    if (error) throw new Error(error);
    return data || [];
  } catch (error) {
    console.error('Error searching artworks:', error);
    return [];
  }
};